<template>
  <div class="m-container">
    <m_header></m_header>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">账户信息</div>
        </div>
      </el-container>
      <div class="m-table">
        <div style="width: 500px; margin: 0 auto;">
          <div class="m-password-title">修改密码</div>
          <el-form ref="subForm" :rules="rules" :model="subForm" label-width="100px">
            <el-form-item label="输入原密码" prop="password">
              <el-input placeholder="请输入原密码" v-model="subForm.password" show-password></el-input>
            </el-form-item>
            <el-form-item label="输入新密码" prop="newPassword">
              <el-input placeholder="请输入新密码" v-model="subForm.newPassword" show-password></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPassword">
              <el-input placeholder="请再次输入新密码" v-model="subForm.checkPassword" show-password></el-input>
            </el-form-item>
            <div v-loading="isLoading" class="m-password-sub">
              <el-button type="primary" @click="submitForm()" class="login-btn" style="width: 200px;">提 交</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'account',
  data () {
    return {
      isLoading: false,
      subForm: {
        password: '',
        newPassword: '',
        checkPassword: '',
        userType: ''
      },
      rules: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        checkPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm () {
      let _this = this
      this.$refs['subForm'].validate((valid) => {
        if (valid) {
          if (_this.subForm.newPassword !== _this.subForm.checkPassword) {
            _this.$message.error('两次密码输入不一致。')
            return
          }
          if (_this.subForm.password === _this.subForm.newPassword) {
            _this.$message.error('与原密码一致，无需修改。')
            return
          }
          _this.isLoading = true
          this.$axios.post('/account/updateManagePassword', _this.subForm)
            .then((res) => {
              if (res.status === 200) {
                _this.$message({
                  message: '修改成功，请重新登录。',
                  duration: 800,
                  type: 'success',
                  onClose: function () {
                    _this.$router.push({name: 'login'})
                    _this.$store.commit('$_removeStorage')
                    _this.isLoading = false
                  }
                })
              } else {
                _this.$message.error(res.msg)
                _this.isLoading = false
              }
            })
        } else {
          return false
        }
      })
    }
  },
  mounted () {
    if (!window.sessionStorage.user) {
      this.$router.push({name: 'login'})
    } else {
      this.subForm.userType = JSON.parse(window.sessionStorage.user).userType
    }
  }
}
</script>

<style scoped>
.m-password-title {
  font-size: 22px;
  margin: 0 0 20px 0;
  text-align: center;
}

.m-password-sub {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Account.vue